import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import store, { RequestStatus, RoomStatus } from '@src/store/index.js';
import Auth from './components/Auth/Auth.jsx';
import Header from './components/Header/Header.jsx';
import Connect from './components/Connect/Connect.jsx';
import ConnectTest from './components/Connect/ConnectTest.jsx';
import Holding from './components/Holding/Holding.jsx';
import Scenario from './components/Scenario/Scenario.jsx';
import Popup from './components/Popup/Popup.jsx';
import PKG from '/package.json';

import './App.css';

function renderPage(connection, roomStatus) {
  if (connection.status === RequestStatus.LOADED) {
    if (roomStatus === RoomStatus.SCENARIO) {
      return <Scenario />;
    }
    return <Holding />;
  }
  return <Connect />;
}

function renderFrame(authenticating, connection, roomStatus, title) {
  if (store.isTest) {
    return <ConnectTest />;
  }
  if (authenticating) {
    return <Auth />;
  } else {
    return (
      <div className="appPage">
        <Header className="appHeader" title={title} />
        {renderPage(connection, roomStatus)}
      </div>
    );
  }
}

export default function App(props) {
  const authenticating = store.user.useSelector(user => user.authenticating);
  const connection = store.connection.use();
  const roomStatus = store.roomState.useSelector(roomState => roomState?.status);
  const scenarioTitle = store.roomState.useSelector(roomState => roomState?.scenarioTitle);
  const completedTitle = store.completion.useSelector(completion => completion.title);
  const title = scenarioTitle || completedTitle || '';
  const popupRef = useRef(null);
  const popup = store.popup.use();
  const PopupContent = popup.content;
  return (
    <div className="appContainer">
      {renderFrame(authenticating, connection, roomStatus, title)}
      <CSSTransition
        nodeRef={popupRef}
        in={popup.active}
        timeout={220}
        classNames="fade-scale-200"
        appear
        unmountOnExit
      >
        <Popup innerRef={popupRef} closePopup={() => store.closePopup()}>
          {PopupContent && <PopupContent />}
        </Popup>
      </CSSTransition>
      {DEBUG && <div className="appBuildVersion">{PKG.version}</div>}
    </div>
  );
}
